<template>
  <div class="slogan-card" :style="{backgroundColor: `${this.bgColor}`}">
    <div class="slogan-card-row container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "SloganCard",
  props: ['bgColor'],
}
</script>

<style scoped lang="less">
.slogan-card {
  width: 100%;
  height: 180px;
  color: white;

  .slogan-card-row {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>